import { useState } from "react";
import Reveal from "@/components/base/Reveal";
import { faqs } from "@/mocks/home";

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-background-100/50 py-16 md:py-24">
      <div className="mx-auto w-full max-w-shell px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-16">
          <Reveal className="lg:col-span-4">
            <div className="lg:sticky lg:top-24">
              <div className="flex items-center gap-3 text-xs font-semibold uppercase tracking-[0.22em] text-primary-600">
                <span className="h-px w-6 bg-primary-500" />
                常见问题
              </div>
              <h2 className="mt-4 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-3xl">
                关于黑料平台
                <br />
                你可能想问的
              </h2>
              <p className="mt-4 text-sm leading-relaxed text-foreground-600">
                这里汇总了访问量最高的几个问题，覆盖功能、内容板块、更新机制与服务方式。
              </p>
              <a
                href="#top"
                className="mt-6 inline-flex items-center gap-2 whitespace-nowrap text-sm font-semibold text-primary-600 hover:text-primary-700"
              >
                <i className="ri-customer-service-2-line" />
                还有疑问？回到顶部看看
              </a>
            </div>
          </Reveal>

          <div className="lg:col-span-8">
            <ul className="space-y-3">
              {faqs.map((faq, index) => {
                const isOpen = openIndex === index;
                return (
                  <Reveal key={faq.q} delay={index * 50}>
                    <li className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
                      <button
                        type="button"
                        onClick={() => setOpenIndex(isOpen ? null : index)}
                        className="flex w-full items-start justify-between gap-4 p-5 text-left transition-colors hover:bg-background-100/60"
                        aria-expanded={isOpen}
                      >
                        <span className="font-heading text-sm font-bold text-foreground-950 md:text-base">
                          {faq.q}
                        </span>
                        <span
                          className={`mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full transition-colors ${
                            isOpen
                              ? "bg-primary-500 text-background-50"
                              : "bg-background-200 text-foreground-600"
                          }`}
                        >
                          <i className={isOpen ? "ri-subtract-line" : "ri-add-line"} />
                        </span>
                      </button>
                      <div
                        className={`grid transition-all duration-300 ease-out ${
                          isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                        }`}
                      >
                        <div className="overflow-hidden">
                          <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600">
                            {faq.a}
                          </p>
                        </div>
                      </div>
                    </li>
                  </Reveal>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}